<template>
    <span>{{count}}</span>
</template>
<script>
export default {
  props: {
    to: {
      required: true,
      type: Number
    },
    divider: {
      required: false,
      type: Number,
      default: 5
    },
  },
  data () {
    return {
      count: 0,
      interval: null
    }
  },
  computed: {
    increment () {
      return Math.ceil(this.to / this.divider)
    }
  },
  mounted () {
    this.setupInterval()
  },
  methods: {
    setupInterval: function () {
      this.count = 0
      this.interval = setInterval(this.tick, 60)
    },
    tick: function () {
      if (this.count + this.increment >= this.to) {
        this.count = this.to
        return clearInterval(this.interval)
      }
      this.count += this.increment
    }
  },
  watch: {
    to: function (value) {
      this.setupInterval()
    }
  }
}
</script>